import { errorParser, ENDPOINT_SEARCH } from '@ott/cars-shared';
import T from '../types.js';
import superagent from '@ott/superagent';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import prepareSearchParams from '../utilities/prepareSearchParams';
import processFetchedData from '../utilities/processFetchedData';
import prepareSearchParamsFromQuery from '../utilities/prepareSearchParamsFromQuery';

let currentReq;
export default (options) => {
  const BASE = _get(options, 'base', '');

  return (data, takeDataFromQuery) => async (dispatch, getState) => {
    const searchParams = takeDataFromQuery
      ? prepareSearchParamsFromQuery(data)
      : prepareSearchParams(getState().cars, data);

    dispatch({ type: T.VARIANTS_GET_START, params: searchParams });

    _get(currentReq, 'abort', _noop)();

    // eslint-disable-next-line no-multi-assign
    const response = (currentReq = await superagent
      .post(BASE + ENDPOINT_SEARCH)
      .timeout(30000)
      .send(searchParams)
      .withCredentials()
      .catch((error) => {
        dispatch({
          type: T.VARIANTS_GET_FAIL,
          error: errorParser(error),
        });
      }));

    if (response) {
      const { body, body: { error, rates = [], isTest } = {} } = response;
      if (error) {
        dispatch({
          type: T.VARIANTS_GET_FAIL,
          error: errorParser(response),
        });
      } else {
        if (rates.length === 0) {
          dispatch({ type: T.VARIANTS_NOTIFY_OF_EMPTY_RATES });
        }
        dispatch({
          type: T.VARIANTS_GET_SUCCESS,
          variants: processFetchedData(body),
          isTestResponse: isTest,
        });
      }
    }
  };
};
